import { memo, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';
import swal2 from '../../../utils/swal2';
import useT from '../../utils/Translations/useT';
import styles from './EntityFormPrompt.scss';
// USE WITH useHistoryPush
const EntityFormPrompt = ({ message, when }) => {
    const history = useHistory();
    const t = useT();
    useEffect(() => {
        if (!when) {
            return undefined;
        }
        const release = history.block((location) => {
            swal2({
                title: message,
                confirmButtonText: t('Proceed'),
                cancelButtonText: t('Remain on page'),
                icon: 'warning',
                className: classnames(styles.modalWrapper),
            }).then(({ isConfirmed }) => {
                if (isConfirmed) {
                    release();
                    history.push(location);
                }
            });
            return false;
        });
        return () => {
            release();
        };
    }, [t, history, when, message]);
    return null;
};
export default memo(EntityFormPrompt);
